// extracted by mini-css-extract-plugin
export default {"MainInput":"MainInput_MainInput__mEfwU","MainInput__input":"MainInput_MainInput__input__KemCy","MainInput__icon":"MainInput_MainInput__icon__MLyBc"};